import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { secureStorage } from '../utils/secureStorage';
import UserAvatar from './UserAvatar';
import './Navbar.css';

export default function Navbar({ 
  title, 
  onLogout, 
  logoClickable = false, 
  onLogoClick = null,
  showUserAvatar = true,
  onStatistikClick = null,
  onAccountClick = null
}) {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  // Lade User-Informationen beim Komponenten-Mount
  useEffect(() => {
    const userData = secureStorage.getUserData();
    if (userData) {
      setUser(userData);
    }
  }, []);

  const handleAvatarUpdate = (updatedUser) => {
    setUser(updatedUser);
  };

  const handleLogout = () => {
    if (onLogout) {
      onLogout();
    } else {
      // Standard-Logout-Verhalten mit sicherer Löschung
      secureStorage.clearToken();
      navigate('/login', { replace: true });
    }
  };

  const handleStatistikClick = () => {
    if (onStatistikClick) {
      onStatistikClick();
    } else {
      // Standard-Statistik-Navigation
      navigate('/statistik');
    }
  };

  const handleAccountClick = () => {
    if (onAccountClick) {
      onAccountClick();
    } else {
      // Standard-Account-Navigation
      navigate('/account');
    }
  };

  const handleLogoClick = () => {
    if (logoClickable && onLogoClick) {
      onLogoClick();
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-content">
        <div 
          className={`navbar-logo${logoClickable ? ' clickable' : ''}`}
          onClick={handleLogoClick}
        >
          <img src="/images/logo.png" alt="Logo" />
        </div>
        <div className="navbar-title">
          {title}
        </div>
        <div className="navbar-right">
          {showUserAvatar && (
            <UserAvatar 
              user={user} 
              onAvatarUpdate={handleAvatarUpdate} 
              onLogout={handleLogout}
              onStatistikClick={handleStatistikClick}
              onAccountClick={handleAccountClick}
            />
          )}
        </div>
      </div>
    </nav>
  );
}
